import { render, staticRenderFns } from "./MoveTransactionToSavingSummary.vue?vue&type=template&id=1a352e44"
import script from "./MoveTransactionToSavingSummary.vue?vue&type=script&lang=js"
export * from "./MoveTransactionToSavingSummary.vue?vue&type=script&lang=js"
import style0 from "./MoveTransactionToSavingSummary.vue?vue&type=style&index=0&id=1a352e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports